import 'containers/coapidemo/CoapiDemo.css';
import 'leaflet/dist/leaflet.css';
import { Form, Container, Row, Col, Button } from "react-bootstrap";
import React, { Component } from "react";
import { API } from "aws-amplify";
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import PropertyDetailModal from './PropertyDetailModal';
import { PacmanLoader } from 'react-spinners';


import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIconShadow from 'leaflet/dist/images/marker-shadow.png';
L.Marker.prototype.options.icon = L.icon({ iconUrl: markerIcon, shadowUrl: markerIconShadow });


export default class CoapiDemo extends Component {
    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.togglePropertyDetailModal = this.togglePropertyDetailModal.bind(this)
        this.map = React.createRef();
        this.state = {
            properties: [],

            isLoading: false,
            showPropertyDetailModal: false,
            activeProperty: {},
        };

        // [<FilterName>, <IsMultiValue>]
        this.filters = [
            ['propertyId', true],
            ['cityscopeReference', true],
            ['cityscopeArea', true],
            ['strataUnitFlag', false],
            ['confidence', false],
            ['fullAddress', false],
            ['streetNumberLow', false],
            ['streetNumberHigh', false],
            ['streetName', false],
            ['mainStreetAddressFlag', false],
            ['suburb', true],
            ['state', false],
            ['postcodeFrom', false],
            ['postcodeTo', false],
            ['latitude', false],
            ['longitude', false],
            ['radiusMetres', false],
            ['polygon', false],
            ['clPropertyId', false],
            ['buildingName', false],
            ['mainPropertyType', true],
            ['propertyType', true],
            ['propertySubType', false],
            ['numberOfUnitsFrom', false],
            ['numberOfUnitsTo', false],
            ['buildingGrade', true],
            ['numberOfStoreysFrom', false],
            ['numberOfStoreysTo', false],
            ['yearBuiltFrom', false],
            ['yearBuiltTo', false],
            ['yearReburbishedFrom', false],
            ['yearRefurbishedTo', false],
            ['hasParkingFlag', false],
            ['numberOfCarBaysFrom', false],
            ['numberOfCarBaysTo', false],
            ['siteAreaFrom', false],
            ['siteAreaTo', false],
            ['floorAreaFrom', false],
            ['floorAreaTo', false],
            ['typicalFloorAreaFrom', false],
            ['typicalFloorAreaTo', false],
            ['nabersEnergyRatingFrom', false],
            ['nabersEnergyRatingTo', false],
            ['numberOfLiftsFrom', false],
            ['numberOfLiftsTo', false],
            ['hasManagingAgencyFlag', false],
            ['managingAgency', false],
        ]
        for (const filter of this.filters) {
            this.state[filter[0]] = '';
        }
    }

    async componentDidMount() {
        if (!this.props.isAuthenticated) return;

    }

    handleChange = event => {
        this.setState({ [event.target.id]: event.target.value });
    }

    async handleSubmit(event) {
        if (event) event.preventDefault();

        this.setState({ isLoading: true });
        const propertyFilters = {}
        for (const filter of this.filters) {
            const filterName = filter[0];
            if (!(!!this.state[filterName])) continue;
            const isMultiValue = filter[1];
            const filterValue = (isMultiValue) ? this.state[filterName].split(',') : this.state[filterName];
            propertyFilters[filter[0]] = filterValue;
        }
        const coapi_response = await API.get("colin", "/coapidemo_search", { 'queryStringParameters': propertyFilters });
        if (coapi_response.results) {
            const properties = coapi_response.results;
            await this.setState({ properties });
            const bounds = this.getMapBounds();
            if (bounds.length) {
                this.map.fitBounds(bounds, { padding: [50, 50] });
            } else {
                this.map.setZoom(3);
                this.map.setView([-26.853387500000004, 133.27515449999999]);
            };
        }
        this.setState({ isLoading: false });
    }

    clearFilters() {
        let state = {};
        for (const filter of this.filters) {
            state[filter[0]] = '';
        }
        this.setState({ ...state });
    }

    propertiesWithLatLong() {
        return this.state.properties.filter(p => p.latitude && p.longitude);
    }

    getMapBounds() {
        return this.propertiesWithLatLong().map(p => [p.latitude, p.longitude]);
    }

    async viewDetail(property) {
        await this.setState({ activeProperty: property });
        this.togglePropertyDetailModal();
    }

    togglePropertyDetailModal() {
        this.setState({ showPropertyDetailModal: !this.state.showPropertyDetailModal });
    }

    render() {
        const tableColumns = [
            {
                id: 'propertyId',
                Header: 'Property ID',
                accessor: 'propertyId',
            },
            {
                id: 'cityscopeReference',
                Header: 'Cityscope Reference',
                accessor: 'cityscopeReference',
            },
            {
                id: 'cityscopeArea',
                Header: 'Cityscope Area',
                accessor: 'cityscopeArea',
            },
            {
                id: 'mainStreetAddress',
                Header: 'Main Street Address',
                accessor: 'mainStreetAddress',
            },
            {
                id: 'mainBuildingName',
                Header: 'Main Building Name',
                accessor: 'mainBuildingName',
            },
            {
                id: 'viewDetail',
                Header: '',
                accessor: null,
                maxWidth: 80,
                Cell: e => <Button variant="secondary" onClick={async () => this.viewDetail(e.original)}>Detail</Button>
            }
        ];

        return (
            <Container fluid>
                <h3>Commercial API Demo</h3>
                <hr />
                <Row>
                    {/* Filters */}
                    <Col md={3} lg={3}>
                        <Form onSubmit={this.handleSubmit}>
                            <Button type="submit" id="submit" className="d-inline-block mb-3">Search Properties</Button>
                            <Button variant="secondary" className="d-inline-block mb-3" onClick={this.clearFilters}>Clear Filters</Button>
                            <Form.Row>
                                <Col >
                                    {this.filters.map(f =>
                                        <Form.Group controlId={f[0]}>
                                            <label className="font-weight-bold">{f}:</label>
                                            {f[1] && <React.Fragment><br/><label className="font-italic">(supports multi-value; separate with commas)</label></React.Fragment>}
                                            <Form.Control
                                                value={this.state[f[0]]}
                                                onChange={this.handleChange}
                                                as="input"
                                                type="text"
                                                key={f[0]} />
                                        </Form.Group>
                                    )}
                                </Col>
                            </Form.Row>
                        </Form>
                    </Col>

                    {/* Map and table */}
                    <Col md={9} lg={9}>
                        {this.state.isLoading &&
                            <div className="outer-div">
                                <div className='sweet-loading inner-div' >
                                    <PacmanLoader
                                        css="display: block; margin: 0 auto; border-color: red"
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#e03c31'}
                                        loading={this.state.isLoading}
                                    />
                                </div>
                            </div>
                        }

                        <div style={{ opacity: (!this.state.isLoading && this.state.properties.length > 0) ? 100 : 0 }}>
                            <MapContainer
                                whenCreated={map => { this.map = map }}
                                center={[-33.865143, 151.209900]}
                                zoom={13}
                                scrollWheelZoom={true}
                            >
                                <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                {this.propertiesWithLatLong().map((p, idx) => (
                                    <Marker position={[p.latitude, p.longitude]} key={idx} data={p} eventHandlers={{
                                        click: async (e) => {
                                            const property = e.target.options.data;
                                            this.viewDetail(property);
                                        },
                                    }}></Marker>
                                ))}
                            </MapContainer>
                        </div>

                        {(!this.state.isLoading && this.state.properties.length > 0) &&
                            <ReactTable
                                data={this.state.properties}
                                columns={tableColumns}
                                sortable={false}
                                defaultPageSize={50}
                            />
                        }
                    </Col>
                </Row>

                {this.state.showPropertyDetailModal &&
                    <PropertyDetailModal
                        show={this.state.showPropertyDetailModal}
                        onClose={this.togglePropertyDetailModal}
                        togglePropertyDetailModal={this.togglePropertyDetailModal}
                        data={this.state.activeProperty}
                    />
                }
            </Container>
        );
    }
}
